import { ClassTypeEnum } from 'pripomienky-web-ts-axios';

enum ClassType {
  PRIPOMIENKA = 'PRIPOMIENKA',
  HROMADNA_PRIPOMIENKA = 'HROMADNA_PRIPOMIENKA',
}

export default ClassType;

export const classTypeToGeneratedMap = new Map([
  [ClassType.PRIPOMIENKA, ClassTypeEnum.Pripomienka],
  [ClassType.HROMADNA_PRIPOMIENKA, ClassTypeEnum.HromadnaPripomienka],
]);

export function classTypeToGenerated(classType: ClassType): ClassTypeEnum {
  return classTypeToGeneratedMap.get(classType);
}
